import React from 'react'
import image1 from '../../Images/Group 25.png'
import image2 from '../../Images/Group 26.png'
import image3 from '../../Images/Group 27.png'
import image4 from '../../Images/infrastructure.png'
import image5 from '../../Images/renewable.png'
import image6 from '../../Images/business.png'
import image7 from '../../Images/mining.png'
import image8 from '../../Images/technology.png'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import BG from '../../Images/cl1.png';
import { useState } from 'react'
import { useEffect } from 'react'
import SanityClient from '../Sanity client'

const IndustryCoverage = () => {

  const [data,setdata]=useState([])
useEffect(() =>{
  const fetch = async()=>{
await SanityClient.fetch(`*[_type == "industrycoverage"]{
  coveragetitle,
  coveragecontent,
  imageslider[]{
    imagetitle,
    coverageimage{
  asset->{
    url
  }
},

}
}
`).then((result)=>{
setdata(result[0])
console.log(result[0]);
})
  }
fetch()
}
,[])

  const settings = {
    dots: true,
    autoplay:true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplaySpeed:2000,
    nextArrow: <></>,
    prevArrow: <></>,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className=' relative bg-cover bg-center px-[5%] md:px-[10%] p-5 md:p-10 bg-primary2 text-black flex flex-col gap-5 justify-center items-center' style={{backgroundImage: `url(${BG})`}}>
      <h1 className='text-center text-lg md:text-3xl font-bold'>Industry Coverage</h1>
      <p className='text-center sm:w-[70%] md:text-base text-sm'>From Investment Banking to Business Financing and HR consulting, our expertise spans across diverse sectors, ensuring tailored solutions for every business need.</p>
      <section className='w-full mb-10 sm:mb-5 h-full'>
        <Slider {...settings}>

        {data && data.imageslider && data.imageslider.map((item, index)=>(<section className='relative xs:w-[70%] p-5 md:w-[20%] flex flex-col justify-end items-center xs:h-auto w-full h-[400px] text-white'>
            <img src={item && item.coverageimage &&item?.coverageimage?.asset?.url} alt='screen' className='w-full h-full'/>
            <h1 className='absolute top-[85%] left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-sm'>{item.imagetitle}</h1>
          </section>))}
         

          {/* <section className='relative xs:w-[70%] p-5 md:w-[20%] flex flex-col justify-end items-center xs:h-auto w-full h-[400px] text-white'>
            <img src={image7} alt='screen' className='w-full h-full'/>
            <h1 className='absolute top-[85%] left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-sm'>Real Estate Finance</h1>
          </section>
          <section className='relative xs:w-[70%] p-5 md:w-[20%] flex flex-col justify-end items-center xs:h-auto w-full h-[400px] text-white'>
            <img src={image3} alt='screen' className='w-full h-full'/>
            <h1 className='absolute top-[85%] left-1/2 -translate-x-1/2 -translate-y-1/2 text-sm text-center'>Renewable Energy</h1>
          </section>
          <section className='relative xs:w-[70%] p-5 md:w-[20%] flex flex-col justify-end items-center xs:h-auto w-full h-[400px] text-white'>
            <img src={image5} alt='screen' className='w-full h-full'/>
            <h1 className='absolute top-[85%] left-1/2 -translate-x-1/2 -translate-y-1/2  text-sm text-center '>Infrastructure Development</h1>
          </section>
          <section className='relative xs:w-[70%] p-5 md:w-[20%] flex flex-col justify-end items-center xs:h-auto w-full h-[400px] text-white'>
            <img src={image6} alt='screen' className='w-full h-full'/>
            <h1 className='absolute top-[85%] left-1/2 -translate-x-1/2 -translate-y-1/2 text-sm'>Technology</h1>
          </section>
          <section className='relative xs:w-[70%] p-5 md:w-[20%] flex flex-col justify-end items-center xs:h-auto w-full h-[400px] text-white'>
            <img src={image2} alt='screen' className='w-full h-full'/>
            <h1 className='absolute top-[85%] left-1/2 -translate-x-1/2 -translate-y-1/2  text-sm'>Healthcare</h1>
          </section>
           <section className='relative xs:w-[70%] p-5 md:w-[20%] flex flex-col justify-end items-center xs:h-auto w-full h-[400px] text-white'>
            <img src={image1} alt='screen' className='w-full h-full'/>
            <h1 className='absolute top-[85%] left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-sm'>Mining and Geology</h1>
          </section>
          <section className='relative xs:w-[70%] p-5 md:w-[20%] flex flex-col justify-end items-center xs:h-auto w-full h-[400px] text-white'>
            <img src={image8} alt='screen' className='w-full h-full'/>
            <h1 className='absolute top-[85%] left-1/2 -translate-x-1/2 -translate-y-1/2 text-sm text-center'>Business Services</h1>
          </section> */}
          
          
          
         
          
          
          
        </Slider>
      </section>
    </div>
  )
}

export default IndustryCoverage
